<template>
	<div class="case">
		<b-row align-v="stretch">
			<b-col cols="12" lg="5" class="d-flex align-items-stretch">
				<case-card-component :data="data"></case-card-component>
			</b-col>
			<b-col cols="12" lg="7">
				<case-infograf-component :data="data.infograph"></case-infograf-component>
			</b-col>
		</b-row>
	
	</div>
</template>

<script>
	const axios = require('axios');
	export default {
		props: {
			data: Object
		},
		data() {
			return {
			}
		},
	}
</script>

<style lang="scss" scoped>

	.case {
		margin-bottom: 35px;
	}
	
</style>